<template>
  <span :style="cssProps">
    <button
      :name="name"
      :disabled="disabled || loading"
      class="button-cadu"
      :class="buttonProps"
      :style="block ? { width: '100%' }: { width: `${this.width}px`}"
      @click="$emit('click')"
    >
        <icon v-if="iconName && !loading" class="icon-button" :name="iconName" :size="iconSize"/>
        <spinner-cadu v-if="loading" line-fg-color="#00995d" :size="20"/>
        <slot v-if="!loading"> {{text}} </slot>
    </button>
  </span>
</template>

<script>
export default {
  props: {
    backColor: {
      type: String,
      default: '#00995d',
      required: false
    },
    textColor: {
      type: String,
      default: '#ffffff',
      required: false
    },
    text: {
      type: String,
      default: '',
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    outline: {
      type: Boolean,
      default: false,
      required: false
    },
    large: {
      type: Boolean,
      default: false,
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: 145
    },
    name: {
      type: String,
      default: ''
    },
    iconName: {
      type: String,
      default: ''
    },
    iconSize: {
      type: Number,
      default: 15
    }
  },
  data () {
    return {
      number: Math.floor((Math.random() * 99999) + 1),
      background: this.backColor,
      dark: 'rgb(0,0,0)'
    }
  },
  computed: {
    buttonProps () {
      return {
        'button-cadu-large': this.large,
        'disabled': this.disabled
      }
    },
    cssProps () {
      return {
        '--background-color': this.outline ? this.textColor : this.backColor,
        '--text-color': this.outline ? this.backColor : this.textColor,
        '--border-width': this.outline ? '1px' : '0',
        '--background-active': this.outline ? this.background : this.pSBC(0.50, this.background, this.dark),
        '--color-active': 'white',
        '--hover': this.backColor
      }
    }
  },
  methods: {
    /* eslint-disable */
    pSBC (p,c0,c1,l) {
      let r; let g; let b; let P; let f; let t; let h; let i = parseInt; let m = Math.round; let a = typeof (c1) === 'string'
      if (typeof (p) !== 'number' || p < -1 || p > 1 || typeof (c0) !== 'string' || (c0[0] != 'r' && c0[0] != '#') || (c1 && !a)) return null
      if (!this.pSBCr) {
        this.pSBCr = (d) => {
          let n = d.length; let x = {}
          if (n > 9) {
            [r, g, b, a] = d = d.split(','), n = d.length
            if (n < 3 || n > 4) return null
            x.r = i(r[3] == 'a' ? r.slice(5) : r.slice(4)), x.g = i(g), x.b = i(b), x.a = a ? parseFloat(a) : -1
          } else {
            if (n == 8 || n == 6 || n < 4) return null
            if (n < 6)d = '#' + d[1] + d[1] + d[2] + d[2] + d[3] + d[3] + (n > 4 ? d[4] + d[4] : '')
            d = i(d.slice(1), 16)
            if (n == 9 || n == 5)x.r = d >> 24 & 255, x.g = d >> 16 & 255, x.b = d >> 8 & 255, x.a = m((d & 255) / 0.255) / 1000
            else x.r = d >> 16, x.g = d >> 8 & 255, x.b = d & 255, x.a = -1
          } return x
        }
      }
      h = c0.length > 9, h = a ? c1.length > 9 ? true : c1 == 'c' ? !h : false : h, f = this.pSBCr(c0), P = p < 0, t = c1 && c1 != 'c' ? this.pSBCr(c1) : P ? { r: 0, g: 0, b: 0, a: -1 } : { r: 255, g: 255, b: 255, a: -1 }, p = P ? p * -1 : p, P = 1 - p
      if (!f || !t) return null
      if (l)r = m(P * f.r + p * t.r), g = m(P * f.g + p * t.g), b = m(P * f.b + p * t.b)
      else r = m((P * f.r ** 2 + p * t.r ** 2) ** 0.5), g = m((P * f.g ** 2 + p * t.g ** 2) ** 0.5), b = m((P * f.b ** 2 + p * t.b ** 2) ** 0.5)
      a = f.a, t = t.a, f = a >= 0 || t >= 0, a = f ? a < 0 ? t : t < 0 ? a : a * P + t * p : 0
      if (h) return 'rgb' + (f ? 'a(' : '(') + r + ',' + g + ',' + b + (f ? ',' + m(a * 1000) / 1000 : '') + ')'
      else return '#' + (4294967296 + r * 16777216 + g * 65536 + b * 256 + (f ? m(a * 255) : 0)).toString(16).slice(1, f ? undefined : -2)
    }
  }
}

</script>

<style lang="sass" scoped>

button::focus 
  border: 0 !important
  outline: none !important

button::-moz-focus-inner
  border: 0 !important
  outline: none !important
  
::-moz-focus-inner
  border: 0
  padding: 0

.button-cadu
  background-color: var(--background-color)
  box-shadow: 0px 2px 5px #0000001A
  border-radius: 20px
  border: none
  color: var(--text-color)
  text-align: center
  text-decoration: none
  display: inline-block
  font-size: 16px
  height: 35px
  width: 145px
  -webkit-transition-duration: 0.4s
  transition-duration: 0.4s

.button-cadu-large
  height: 42px
  width: 155px

.disabled 
    opacity: 0.6
    cursor: not-allowed
    border-style: solid
    border-width: var(--border-width)
    border-color: var(--background-color)

.button-cadu:enabled:active
  background-color: var(--background-active) !important
  color: var(--color-active) !important

.button-cadu:enabled:hover
  border-style: solid
  border-width: var(--border-width)
  border-color: var(--hover)
  -webkit-transition-duration: 0.4s
  transition-duration: 0.4s

.button-cadu:active:after 
  padding: 0
  margin: 0
  opacity: 0
  transition: 0s



</style>